import React from 'react';
import {Link} from '../raw-components/link/link';
import {CyClass} from "../../../common/cy-classes";
import {observer} from 'mobx-react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {HomePageHeaderArena} from '../../services/configurations/config-data-sections/home-page.configuration';
import {HomepageHeaderArenaIconBox} from './boxes/home-page-header-arena-icon/home-page-header-arena-icon.box';
import {HomepageHeaderArenaTitleBox} from './boxes/home-page-header-arena-title/home-page-header-arena-title.box';
import {HomepageHeaderArenaBadgeBox} from './boxes/home-page-header-arena-badge/home-page-header-arena-badge.box';
import {HomePageHeaderArenasContainerBox} from './boxes/home-page-header-arenas-container.box';
import {HomepageHeaderArenaLinkBox} from './boxes/home-page-header-arena-link/home-page-header-arena-link.box';
import {HomePageHeaderArenaIconComponent} from "./home-page-header-arena-icon.component";
import { SeoConfiguration } from '../../services/configurations/config-data-sections/seo.configuration';

const NEW_GAMES_TITLE = "NEW_GAMES";

interface HomePageHeaderArenasComponentProps {
    useSmallHeaderArenas: boolean;
}

@observer
export class HomePageHeaderArenasComponent extends OrbitComponent<HomePageHeaderArenasComponentProps> {

  private _getSeo(prop: keyof SeoConfiguration["categories"]["images"], placeholder: string, dynamic: string) {

    let seoValue = '';
    let seoConfig = this.services.configuration.data.seo;

    if (seoConfig && seoConfig.categories && seoConfig.categories.images && seoConfig.categories.images[prop]) {
      seoValue = seoConfig.categories.images[prop];
    }

    return this.services.translation.translate(seoValue, {
      [placeholder]: this.services.translation.translate(dynamic)
    });
  }

  private _handleArenaAction = (action: string, index: number) => {
    try {
      const jsonAction = JSON.parse(action);

      if (jsonAction.action === 'game-real') {

          const gameInfo = this.services.games.gamesMap[jsonAction.id];

          gameInfo.open({
            isRealMode: true,
            gameIndex: index
          });
      }

    } catch (error) {
      this.services.logger.error(`Error in HomePageHeaderArenasComponent '_handleArenaAction', error: ${error}, value:${action}`)
    }
  };

  private _handleArenaRedirect = (link: string) => {
    /**
     * @desc added because of parallel actions [navigation + spinner]
     * F TO DO - This setTimeout was added by regev on 09/04/2018 in this commit 962fbdea53e3bc8828a215ed035fc0e9243b7a50. I should check if this really solves a performance issue.
     * we should keep this delay so that on mobile the user has time to see the image changing sizes upon touching, as a form of feedback
     */
    setTimeout(() => {
      this.services.location.push(link); // navigation is done this way, so we can have the trailing slash
    }, 500);
  };

  private _handleArenaClick(event: any, arena: HomePageHeaderArena, index: number): void {

    event.preventDefault();
    this.services.analytics.sendAnalytics('Game Grid', 'Home', `${arena.title}_${index}`);

    if (arena.action) {
      this._handleArenaAction(arena.action, index);
    } else if (arena.link) {
      this._handleArenaRedirect(arena.link);
    }
  }

  private _renderArenaIcon(arena: HomePageHeaderArena): React.ReactNode {
    return (
      <HomePageHeaderArenaIconComponent
        src={arena.image}
        enableTap={this.services.device.isMobile}
        lazy={true}
        className={'arena-img'}
        fallbackSrc={this.services.configuration.data.generalSettings.gamesSettings.homePageArenaDefaultPlaceHolder}
        alt={this._getSeo('alt', 'categoryName', arena.title)}
        title={this._getSeo('title', 'categoryName', arena.title)}
      />
    );
  }

  private _renderOneHeaderArena(arena: HomePageHeaderArena, index: number) {
    const hasNewGamesIndication = arena.title === NEW_GAMES_TITLE && this.services.homepage.newAddedGames > 0;
    const newGamesIndication = hasNewGamesIndication ?
      <HomepageHeaderArenaBadgeBox className={CyClass('cy-new-games-arena-badge')}>
        {this.services.homepage.newAddedGames > 10? '10+' : this.services.homepage.newAddedGames}
      </HomepageHeaderArenaBadgeBox>
      : null;

    return (
      <HomepageHeaderArenaIconBox
        key={arena.title}
        className={CyClass('cy-arena-box')}
        onClick={(event) => this._handleArenaClick(event, arena, index)}
        useSmallHeaderArenas={this.props.useSmallHeaderArenas }
      >
        {/*We need this href only for SEO*/}
        <Link href={arena.link} enableTap={this.services.device.isMobile} box={HomepageHeaderArenaLinkBox}>
          {this._renderArenaIcon(arena)}
          <HomepageHeaderArenaTitleBox>
            <span className={CyClass('cy-header-arena-title')}>{this.services.translation.translate(arena.title)}</span>
            {newGamesIndication}
          </HomepageHeaderArenaTitleBox>
        </Link>
      </HomepageHeaderArenaIconBox>
    );
  }

  render() {

    const headerArenas = this.services.homepage.headerArenas;

    if(headerArenas.length === 0) {
      return null;
    }

    return (
      <HomePageHeaderArenasContainerBox className={'cy-homepage-header-arenas-container'} useSmallHeaderArenas={this.props.useSmallHeaderArenas}>
        {headerArenas.map((arena, index) => this._renderOneHeaderArena(arena, index))}
      </HomePageHeaderArenasContainerBox>
    );
  }
}
